/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteTaskCommand } from '../../models/delete-task-command';
import { DeleteTaskCommandResult } from '../../models/delete-task-command-result';

export interface ApiTaskDeleteTaskDelete$Params {
      body?: DeleteTaskCommand
}

export function apiTaskDeleteTaskDelete(http: HttpClient, rootUrl: string, params?: ApiTaskDeleteTaskDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiTaskDeleteTaskDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteTaskCommandResult>;
    })
  );
}

apiTaskDeleteTaskDelete.PATH = '/api/Task/DeleteTask';
